import Vue from "vue"
import Router from "vue-router"


// import Home from "@/pages/Home/home.vue"
import Home from "@/pages/Home/HomeDoor/index.vue"
import login from "@/pages/Home/HomeDoor/login.vue"
import main from "@/pages/Home/HomeDoor/main.vue"
import wordDetail from "@/pages/Home/wordDetail.vue"
import tableDetail from "@/pages/Home/tableDetail.vue"
import wordDetailPromotion from "@/pages/Home/wordDetailPromotion.vue"
import tableDetailPromotion from "@/pages/Home/tableDetailPromotion.vue"
import wordSearchDetail from "@/pages/Home/wordSearchDetail.vue"


Vue.use(Router)

export const constantRoutes =[
  {
    name: "home",
    path: "/home",
    component: Home
  },
  {
    name: "login",
    path: "/login",
    component: login
  },
  {
    name: "main",
    path: "/main",
    component: main
  },
  {
    name: "wordDetail",
    path: "/wordDetail",
    component: wordDetail
  },
    {
      name: "tableDetail",
      path: "/tableDetail",
      component: tableDetail
    },
    {
      name: "wordDetailPromotion",
      path: "/wordDetailPromotion",
      component: wordDetailPromotion
    },
    {
      name: "tableDetailPromotion",
      path: "/tableDetailPromotion",
      component: tableDetailPromotion
    },
    {
      name: "wordSearchDetail",
      path: "/wordSearchDetail",
      component: wordSearchDetail
    },

  //cyc静态页面到此结束
  {
    path: "*",
    redirect: "/home"
  }
  ]


export default new Router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});